import * as React from "react";
import { FC } from "react";

import { Linetext } from "../../../ValueViewers/Linetext/Linetext";

import { DeleteBlockButton } from "./DeleteBlockButton";

interface VisibleBlockProps {
    showingDeleteButton: boolean;
    title?: string;
    onDeleteBlock: () => void;
}

export const VisibleBlock: FC<VisibleBlockProps> = ({ showingDeleteButton = true, title, children, onDeleteBlock }) => (
    <div>
        <div>
            {title && (
                <Linetext marginRight={"15px"} fontWeight={"bold"}>
                    {title}
                </Linetext>
            )}

            {showingDeleteButton && <DeleteBlockButton onClick={onDeleteBlock} />}
        </div>

        {children}
    </div>
);
